import { z } from "zod";
/** Phase 2b quiz contracts. Content (questions + keys) is admin-managed; the
 * student-facing payloads never carry the correct answers. */
export const QUIZ_SUBMISSION_STATUSES = ["in-progress", "submitted"];
const choiceKey = z.string().trim().min(1).max(4); // e.g. "A".."D"
export const quizChoiceSchema = z.object({
    key: choiceKey,
    text: z.string().trim().min(1).max(800),
});
/** One question as imported by an admin (includes the correct answer). */
export const quizQuestionImportSchema = z
    .object({
    prompt: z.string().trim().min(1).max(2000),
    choices: z.array(quizChoiceSchema).min(2).max(8),
    correctKey: choiceKey,
})
    .refine((q) => q.choices.some((c) => c.key === q.correctKey), {
    message: "correctKey must match one of the choices",
    path: ["correctKey"],
});
/** Bulk import of one quiz set's content (quizId comes from the route). */
export const quizImportSchema = z.object({
    title: z.string().trim().min(1).max(120),
    setNumber: z.number().int().min(1).max(20),
    questions: z.array(quizQuestionImportSchema).min(1).max(200),
});
/** Student progress/submit payload: questionId -> chosen choice key. */
export const quizAnswersSchema = z.object({
    answers: z.record(z.string(), choiceKey).default({}),
});
export const DEFAULT_CNA_QUIZ_PLAN = [
    { week: 1, quizId: "set-1" },
    { week: 2, quizId: "set-2" },
    { week: 3, quizId: "set-3" },
    { week: 4, quizId: "set-4" },
];
//# sourceMappingURL=quiz.js.map